import React, { useState } from 'react';
import ReactPlayer from 'react-player/youtube'

import styles from './VideoPlayerModal.module.scss';
import closeIcon from 'Assets/Icons/closeIcon.svg'

const VideoPlayerModal = ({ setModal, videoModalState, url }) => {

  // we need this to and mentioning the onPlay and onPause below
  // to be able to stop the player when closing the modal
  const [playing, setPlaying] = useState(false);

  return (
    <div className={`modal ${videoModalState && 'show'}`} onClick={(e) => { e.stopPropagation() }}>
      <div className={`${styles.container} ${styles.videoModal}`} onClick={(e) => e.stopPropagation()}>
      <ReactPlayer 
        controls={true} 
        height={"100%"} 
        width={"100%"} 
        url={url}
        playing={playing}
        onPlay={() => setPlaying(true)}
        onPause={() => setPlaying(false)} />
        <div className={styles.closingBtn} onClick={(e) => { setPlaying(false); e.stopPropagation(); setModal(false);} }>
          <img src={closeIcon} alt='close icon' />
        </div>
      </div>
    </div>
  )
}

export default VideoPlayerModal;